import { render } from "./RappresentanteDialogCore.vue?vue&type=template&id=e0ad7cac&scoped=true"
import script from "./RappresentanteDialogCore.vue?vue&type=script&lang=js"
export * from "./RappresentanteDialogCore.vue?vue&type=script&lang=js"

import "./RappresentanteDialogCore.vue?vue&type=style&index=0&id=e0ad7cac&scoped=true&lang=css"
import "./RappresentanteDialogCore.vue?vue&type=style&index=1&id=e0ad7cac&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ad7cac"]])

export default __exports__